export function showVideo({ videoUploadToolsIsOn, vimeoId, videoStatus, videoReviewStatus }) {
    return (
        vimeoId &&
        videoStatus === 'available' &&
        ((videoUploadToolsIsOn && videoReviewStatus === 'APPROVED') || !videoUploadToolsIsOn)
    );
}
